import { Component, inject, Input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { notify, SiaTranslatePipe, YesNoDialogComponent } from '@sia/shared';
import { firstValueFrom } from 'rxjs';
import { GoogleAuthService } from '../../services/google-auth.service';

@Component({
  selector: 'sia-google-logout-button',
  templateUrl: './sia-google-logout-button.component.html',
  styleUrls: ['./sia-google-logout-button.component.scss'],
  standalone: true,
  imports: [MatButton, SiaTranslatePipe, MatIcon],
})
export class SiaGoogleLogoutButtonComponent {
  #googleAuthService = inject(GoogleAuthService);
  #dialog = inject(MatDialog);

  @Input() isLogged?: boolean;
  @Input() scope?: string;
  @Input() buttonText?: string;
  @Input() disabled?: boolean;
  loginChanged = output();

  async gLogout() {
    if (!this.scope) {
      notify(
        'Logout google non possibile: scope o email mancanti',
        2000,
        'error',
      );
      return;
    }
    const dialogRef = this.#dialog.open(YesNoDialogComponent, {
      width: '350px',
      data: {
        title: 'Google logout',
        text: 'Vuoi cancellare i tuoi calendari sales connect su google?',
        negativeMeaning: true,
      },
    });
    if (!(await firstValueFrom(dialogRef.afterClosed()))) {
      return;
    }
    const res = await this.#googleAuthService.logout(this.scope);
    if (!res) {
      notify('Logout google non riuscito', 2000, 'error');
      return;
    }
    this.isLogged = false;
    this.loginChanged.emit();
  }
}
